/**
 * Statik site içerikleri — istanbulrotary.org kaynaklı (scripts/build-static-site-data.mjs).
 */
import homeBannerNews from './generated/homeBannerNews.json';
import haberItems from './generated/haberItems.json';
import newsListAll from './generated/newsListAll.json';
import newsById from './generated/newsById.json';
import boardInfo from './generated/boardInfo.json';
import boardSections from './generated/boardSections.json';
import pastPresidents from './generated/pastPresidents.json';
import homeStats from './generated/homeStats.json';

/** @type {import('../../api/cmsNews').CmsNewsItem[]} */
export const STATIC_HOME_BANNER_NEWS = homeBannerNews;

/** @type {Array<{ id: string, imageUrl: string, publishedAt: string, title: string, excerpt: string, href: string }>} */
export const STATIC_HABER_ITEMS = haberItems;

export const STATIC_HOME_STATS = homeStats;

/** @type {Array<{ id: string, imageUrl: string, title: string, description: string, href: string }>} */
export const STATIC_PROJECT_ITEMS = [];

/** @type {null | { term: string, title: string, description: string | null }} */
export const STATIC_BOARD_INFO = boardInfo;

/** @type {Array<{ key: string, sectionTitle?: string, members: unknown[] }>} */
export const STATIC_BOARD_SECTIONS = boardSections;

/** @type {Array<{ period: string, name: string, image: string }>} */
export const STATIC_PAST_PRESIDENTS = pastPresidents;

/** @type {Record<string, import('../../api/cmsNews').CmsNewsDetail>} */
export const STATIC_NEWS_BY_ID = newsById;

/** @type {Record<string, import('../../api/cmsProjects').CmsProjectDetail>} */
export const STATIC_PROJECTS_BY_ID = {};

/** @type {Array<{ id: string, imageUrl: string, publishedAt: string, title: string, excerpt: string, href: string }>} */
export const STATIC_NEWS_LIST_ALL = newsListAll;

/** @type {import('../../data/bulletins').Bulletin[]} */
export const STATIC_NEWSLETTERS_ALL = [];

/** @type {unknown[]} */
export const STATIC_MEMBERS_DIRECTORY = [];

/** @type {unknown[]} */
export const STATIC_MEMBER_GROUPS = [];

/** @type {unknown[]} */
export const STATIC_GALLERY_LIST = [];

/** @type {Record<string, unknown>} */
export const STATIC_GALLERY_BY_SLUG = {};

/** @type {unknown[]} */
export const STATIC_CALENDAR_EVENTS = [];

/**
 * @param {number} pageNumber
 * @param {number} pageSize
 */
export function sliceStaticNewsListPage(pageNumber, pageSize) {
    const totalCount = STATIC_NEWS_LIST_ALL.length;
    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize) || 1);
    const currentPage = Math.min(Math.max(1, pageNumber), totalPages);
    const start = (currentPage - 1) * pageSize;
    return {
        items: STATIC_NEWS_LIST_ALL.slice(start, start + pageSize),
        meta: {
            totalCount,
            totalPages,
            currentPage,
            pageSize,
            hasNext: currentPage < totalPages,
            hasPrevious: currentPage > 1,
        },
    };
}

/**
 * @param {number} pageNumber
 * @param {number} pageSize
 */
export function sliceStaticNewslettersPage(pageNumber, pageSize) {
    const totalCount = STATIC_NEWSLETTERS_ALL.length;
    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize) || 1);
    const currentPage = Math.min(Math.max(1, pageNumber), totalPages);
    const start = (currentPage - 1) * pageSize;
    return {
        items: STATIC_NEWSLETTERS_ALL.slice(start, start + pageSize),
        meta: {
            totalCount,
            totalPages,
            currentPage,
            pageSize,
            hasNext: currentPage < totalPages,
            hasPrevious: currentPage > 1,
        },
    };
}

/**
 * @param {string | undefined} newsId
 */
export function getStaticNewsById(newsId) {
    if (!newsId) return null;
    return STATIC_NEWS_BY_ID[newsId] ?? null;
}

/**
 * @param {string | undefined} projectId
 */
export function getStaticProjectById(projectId) {
    if (!projectId) return null;
    return STATIC_PROJECTS_BY_ID[projectId] ?? null;
}

/**
 * @param {string | undefined} slug
 */
export function getStaticGalleryBySlug(slug) {
    if (!slug) return null;
    return STATIC_GALLERY_BY_SLUG[slug] ?? null;
}
